import { UserDataLayerAdapterFactory } from "../shared/UserDataLayerAdapterFactory";
import { User } from "../gtm/User";
import { UserDataLayerAdapter } from "../shared/UserDataLayerAdapter";
import { DotCaUserDataLayerAdapter } from "./DotCaUserDataLayerAdapter";

export class DotCaUserDataLayerAdapterFactory extends UserDataLayerAdapterFactory {
  override getUserDataAdapter(user: User): UserDataLayerAdapter {
    return new DotCaUserDataLayerAdapter(user);
  }
}
